<template>
  <div>
    <van-nav-bar
      title="成交查询"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <div class="topContent" style="font-size: 14px">
      <van-row class="dateFilter"
        ><van-col span="4" class="rowStyle"><span>历史成交:</span></van-col>
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="startDate"
              @click="startStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="startStatus" position="bottom">
              <van-datetime-picker
                style="color: red"
                v-model="date"
                @confirm="onConfirmStartDate"
                @cancel="startStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="1" class="rowStyle" style="text-align: center"
          ><span>--</span></van-col
        >
        <van-col span="7" class="rowStyle calanderStyle">
          <van-cell-group>
            <van-cell
              :value="endDate"
              @click="endStatus = true"
              style="padding: 1px; padding-left: 15px"
            />
            <van-popup v-model="endStatus" position="bottom">
              <van-datetime-picker
                v-model="date"
                @confirm="onConfirmEndDate"
                @cancel="endStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup> </van-cell-group
        ></van-col>
        <van-col span="5" class="rowStyleBtn" style="text-align: center"
          ><van-button
            type="danger"
            size="small"
            style="height: 30px"
            @click="getDeal"
            >查询</van-button
          ></van-col
        >
      </van-row>
      <van-row class="details"
        ><van-col span="12" class="rowStyle"
          ><p>
            买入额: ¥<span>{{ totalbuy.toFixed(2) }}</span>
          </p></van-col
        >
        <van-col span="12" class="rowStyle"
          ><p>
            卖出额: ¥<span>{{ totalsell.toFixed(2) }}</span>
          </p></van-col
        >
      </van-row>
    </div>
    <div class="tableContent">
      <div class="tableheading" style="font-size: 14px">
        <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <th>名称代码</th>
            <th>交易方向</th>
            <th>成交数量</th>
            <th>成交价格</th>
            <th>成交金额</th>
            <th>券商佣金</th>
            <th>印花税</th>
            <th>交易征费</th>
            <th>交易费</th>
            <th>结算交收费</th>
            <th>平台费用</th>
            <th>财汇局交易征费</th>
            <th>多头/空头</th>
            <th>成交时间</th>
          </tr>
        </table>
      </div>
      <div class="tabledata">
        <van-list
          v-model="loadingDeal"
          :finished="finishedDeal"
          finished-text="没有更多了"
        >
          <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
            <tr
              class="stock_td"
              v-for="(item, index) in unwindData"
              :key="index"
            >
              <td>
                <p>
                  <span>{{
                    item.name.length >= 4
                      ? item.name.substr(0, 4) + "..."
                      : item.name
                  }}</span
                  ><br /><span>{{ item.code }}</span>
                </p>
              </td>
              <td>
                <p v-bind:style="item.isBuy == 0 ? 'color:green' : 'color:red'">
                  {{ item.type }}
                </p>
              </td>
              <td>
                <p>{{ item.number }}</p>
              </td>
              <td>
                <p>{{ parseFloat(item.price).toFixed(3) }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.total }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.commission }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.stamp }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.change }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.extra_fee1 }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.extra_fee2 }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.extra_fee3 }}</p>
              </td>
              <td>
                <p style="color: red">{{ item.chj_levy }}</p>
              </td>
              <td>
                <p>{{ item.direction }}</p>
              </td>
              <td>
                <p>{{ item.time }}</p>
              </td>
            </tr>
          </table>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DealInquiry",
  data() {
    return {
      date: new Date(),
      startStatus: false,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endStatus: false,
      endDate: this.$moment().format("YYYY-MM-DD"),
      unwindData: [],
      totalbuy: 0,
      totalsell: 0,
      loadingDeal: false,
      finishedDeal: false,
    };
  },

  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getUnwindData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_deal",
            token: window.sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            let entrust = resData.data;
            let unwindData = [];
            for (let i = 0, len = entrust.length; i < len; i++) {
              if (entrust[i].depot_mold === 1) {
                unwindData.push(entrust[i]);
                that.totalbuy = that.totalbuy + parseFloat(entrust[i].total);
              } else {
                that.totalsell = that.totalsell + parseFloat(entrust[i].total);
              }
            }
            //that.unwindData = unwindData;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    getDeal() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_deal",
            token: window.sessionStorage.getItem("token"),
            start: that.startDate,
            end: that.endDate,
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.unwindData = resData.data;
            that.loadingDeal = false;
            that.finishedDeal = true;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          that.loadingDeal = false;
          that.finishedDeal = true;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
    onConfirmStartDate(time) {
      this.startDate = this.$moment(time).format("YYYY-MM-DD");
      this.startStatus = false;
    },
    onConfirmEndDate(time) {
      this.endDate = this.$moment(time).format("YYYY-MM-DD");
      this.endStatus = false;
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getUnwindData();
    that.getDeal();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.topContent {
  /* height: 125px; */
  background: #ffffff;
  /* position: fixed;
  top: 42px;
  left: 0;
  width: 100%; */
}

.dateFilter {
  padding: 10px 5px;
  /* position: fixed;
  top: 56px;
  left: 0;
  width: 100%; */
  /* border-bottom: 1px solid #ebedf0; */
  /* padding-bottom: 10px; */
}

.rowStyle {
  height: 30px;
  line-height: 30px;
}

.calanderStyle {
  border: 1px solid #969799;
}

.rowStyleBtn {
  line-height: 20px;
}

.tableheading {
  font-size: 14px;
  /* position: sticky;
  top: 140px; */
  padding-bottom: 10px;
  text-align: center;
  /* width: 100%; */
  width: 880px;
}

.tabledata {
  font-size: 14px;
  /* margin-top: 145px; */
}

.details {
  /* position: fixed;
  top: 110px;
  left: 0;
  width: 100%; */
  padding-bottom: 10px;
  text-align: center;
}

.details p {
  line-height: 20px;
  margin: 0;
}

.rowData {
  border-bottom: 1px solid rgb(235, 237, 240);
  padding: 10px 0px;
}

.stockTable {
  text-align: left;
  width: 880px;
}

.stockTable p {
  margin: 3px 0px;
}

.stockTable th,
.stockTable td {
  width: 80px;
  text-align: center;
}

.tableContent {
  /* margin-top: 10px; */
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100vw;
}
</style>


// WEBPACK FOOTER //
// src/components/DealInquiry.vue